"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_apollo_1 = require("react-apollo");
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const utils_1 = require("@8base/utils");
const permissions_provider_1 = require("@8base-react/permissions-provider");
const createRecordTag = (tableSchema, mode, options) => {
    switch (mode) {
        case 'create':
            return utils_1.createTableRowCreateTag([tableSchema], tableSchema.id, options);
        case 'createMany':
            return utils_1.createTableRowCreateManyTag([tableSchema], tableSchema.id);
        case 'update':
            return utils_1.createTableRowUpdateTag([tableSchema], tableSchema.id, options);
        case 'delete':
            return utils_1.createTableRowDeleteTag([tableSchema], tableSchema.id);
        default:
            return '';
    }
};
class RecordCrud extends react_1.Component {
    render() {
        const _a = this.props, { tableSchema, children, mode, includeColumns } = _a, rest = __rest(_a, ["tableSchema", "children", "mode", "includeColumns"]);
        const mutation = graphql_tag_1.default(createRecordTag(tableSchema, mode, {
            permissions: this.context.permissions,
            includeColumns: includeColumns || null,
        }));
        return (react_1.default.createElement(react_apollo_1.Mutation, Object.assign({}, rest, { mutation: mutation }), (mutateFunction, mutateResult) => children(mutateFunction, mutateResult)));
    }
}
exports.RecordCrud = RecordCrud;
RecordCrud.contextType = permissions_provider_1.PermissionsContext;
//# sourceMappingURL=RecordCrud.js.map